/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

const ls = new SecureLS({ isCompression: false });

import { account } from "./account.module";
import { agence } from "./agence.module";
import { alert } from "./alert.module";
import { user } from "./user.module";
import { role } from "./role.module";
import { leftsidebar } from "./leftsidebar.module";
import { work } from "./work.module";
import { contact } from "./contact.module";
import { notification } from "./notification.module";
import { document } from "./document.module";
import { simulation } from "./simulation.module";
import { filter } from "./filter.module";
import { loader } from "./loader.module";
import { period } from "./period.module";
import { contract } from "./contract.module";
import { regulation } from "./regulation.module";
import { estimation } from "@/store/estimation.module";
import {operation} from "./operation.module";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    account,
    agence,
    alert,
    user,
    notification,
    leftsidebar,
    work,
    document,
    simulation,
    filter,
    loader,
    contact,
    period,
    contract,
    role,
    regulation,
    estimation,
    operation
  },
  plugins: [
    createPersistedState({
      paths: ["account.user", "account.userInfo"],
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key)
      }
    })
  ]
});
